import { Layout, Menu } from 'antd';
import React from 'react';
import { useLocation, Link } from 'react-router-dom';

import { ROUTES } from '@/constants';
import { useGacha } from '@/hooks/context/GachaContext';

const createMenuItems = (gachaId: string) => [
  {
    to: `/gacha/${gachaId}`,
    label: 'ガチャ情報',
  },
  {
    to: `/gacha/${gachaId}/gift-code`,
    label: 'ギフトコードの一覧',
  },
  {
    to: `/gacha/${gachaId}/gift-code/add`,
    label: 'ギフトコードの追加',
  },
  {
    to: `/gacha/${gachaId}/register`,
    label: '事前登録者一覧',
  },
  {
    to: `/gacha/${gachaId}/winning`,
    label: '当選者一覧',
  },
  {
    to: `/gacha/${gachaId}/winning/unapproved`,
    label: '未承認当選者一覧',
  },
  {
    to: `/gacha/${gachaId}/email/send`,
    label: 'メール送信',
  },
  {
    to: ROUTES.topGacha,
    label: 'その他のガチャ',
    targetBlank: true,
  },
];

const Sider: React.FC<{}> = () => {
  const location = useLocation();
  const { gacha } = useGacha();
  return (
    <Layout.Sider className="site-layout-background" breakpoint="lg" collapsedWidth="0">
      <Menu mode="inline" theme="dark" selectedKeys={[location.pathname]}>
        {createMenuItems(gacha.id).map((menu) => (
          <Menu.Item key={menu.to}>
            <Link to={menu.to} target={menu.targetBlank ? '_blank' : ''}>
              {menu.label}
            </Link>
          </Menu.Item>
        ))}
      </Menu>
    </Layout.Sider>
  );
};

export default Sider;
